import { Component, OnInit } from '@angular/core';
import { Wcb } from '../../../classes/wcb';
import { Province } from '../../../classes/province';
import { ProvinceService } from '../../../services/province.service';
import { WcbService } from '../../../services/wcb.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-wcb-page',
  templateUrl: './wcb-page.component.html',
  styleUrls: ['./wcb-page.component.scss']
})
export class WcbPageComponent implements OnInit {


  constructor(
    private provinceService: ProvinceService,
    private WcbService: WcbService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService,
    private router: Router
  ) { }

  wcb: Wcb = <Wcb>{};
  wcbs: Wcb[] = [];
  provinces: Province[] = this.provinceService.getProvinces();
  edit: boolean[] = [];
  editing: boolean[] = [];
  sub: any;
  orgId: number;
  adding: boolean;
  isAdmin: boolean;
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  focus: any[] = [];
  provFocus: boolean = false;
  rateFocus: boolean = false;
  noteFocus: boolean = false;
  error: string;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.getWcbs();
      this.getComplete();
    });
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
    this.titleService.setTitle('WCB');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 3).some(s => {
          console.log(s)
          return !s[2];
        })
        this.state = JSON.parse(company.state);

      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getWcbs() {
    this.WcbService.getWcb(this.orgId)
      .subscribe(w => {
        console.log(w)
        this.wcbs = JSON.parse(w.wcb_details || '[]');
        this.edit = this.wcbs.map((w) => {
          return false;
        })
        this.editing = JSON.parse(JSON.stringify(this.edit));
        this.focus = this.wcbs.map((w) => {
          return {
            provFocus: false,
            rateFocus: false,
            noteFocus: false,
          };
        })
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  addWcb(wcbForm: NgForm) {
    this.adding = true;
    if (wcbForm.invalid) {
      return;
    }
    if (+this.wcb.wcb_rate > 100) {
      this.wcb.wcb_rate = 100;
    }
    this.WcbService.addWcb(this.orgId, this.wcb)
      .subscribe(e => {
        this.adding = false;
        this.getWcbs();
        this.getComplete();
        wcbForm.reset();
        this.wcb = <Wcb>{};
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  editWcb(index: number) {
    this.edit[index] = true;
  }

  completeEdit(id: number, wcb: Wcb, wcbForm: NgForm, index: number) {
    this.editing[index] = true;
    if (wcbForm.invalid) {
      return;
    }
    if (+wcb.wcb_rate > 100) {
      wcb.wcb_rate = 100;
    }
    this.WcbService.editWcb(this.orgId, id, wcb)
      .subscribe(e => {
        this.editing[index] = false;
        this.getWcbs();
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  deleteWcb(id: number) {
    this.WcbService.deleteWcb(this.orgId, id)
      .subscribe(e => {
        this.getWcbs();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  showError(ev: string) {
    this.error = ev;
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/wcb-page/wcb-page.component.ts